import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

type PropsType = {
  tabs: {
    id: string;
    title: string;
    Content: ReactNode;
    onChange: () => void;
  }[];
  activeTabId: string;
};

const TabComponent: FC<PropsType> = ({ tabs, activeTabId }: PropsType) => {
  const activeTab = tabs.find(({ id }) => id === activeTabId);

  return (
        <>
            <div className="flex items-center justify-center">
                {tabs.map(({ title, id, onChange }) => {
                  const isActiveTab = id === activeTabId;

                  return (
                        <div
                            key={id}
                            onClick={onChange}
                            className={classNames('p-[8px] text-18', { 'text-primary2 cursor-pointer': !isActiveTab })}
                        >
                            {title}
                        </div>
                  );
                })}
            </div>
            {activeTab && <div className="mt-8">{activeTab.Content}</div>}
        </>
  );
};

export default TabComponent;
